import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { VendorLookupComponent } from '../../../Lookup/vendor-lookup/vendor-lookup.component';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { UnitsOfMeasure, Warehouse } from '../../../../model/administration.model';
import { Department, GSTInfo, Product, RecentInteractions, UpdateInventory, gridPageRequest } from '../../../../model/common/common.model';
import { AdministratorService } from '../../../../services/administrator.service';
import { ConfirmationService, MessageService, MenuItem } from 'primeng/api';
import { TermscodeLookupComponent } from '../../../Lookup/termscode-lookup/termscode-lookup.component';
import { PurchaseorderService } from '../../../../services/purchaseorder.service';
import { ActivatedRoute, Router } from '@angular/router';
import { SalesService } from '../../../../services/sales.service';
import { LoaderComponent } from '../../../loader/loader.component';
import _, { create } from 'lodash';
import { ShipToCustomerLookupComponent } from '../../../Lookup/shiptocustomer-lookup/shiptocustomer-lookup.component';
import { CustomerService } from '../../../../services/customer.service';
import { InventoryService } from '../../../../services/inventory.service';
import { viewproductLookupComponent } from '../../../Lookup/viewproduct-lookup/viewproduct-lookup.component';
import { VendorService } from '../../../../services/vendor.service';
import { CloseQuickProductLookupComponent } from '../../../Lookup/close-quick-product-lookup/close-quick-product-lookup.component';
import { POCommentsLookupComponent } from '../../../Lookup/pocomments-lookup/pocomments-lookup.component';
import { ListLinkedFilesLookupComponent } from '../../../Lookup/List-Linked-Files-lookup/list-linked-files.lookup.component';
import { CloseQuickVendorLookupComponent } from '../../../Lookup/close-quick-vendor-lookup/close-quick-vendor-lookup.component';
import { UOMLookupComponent } from '../../../Lookup/uomlookup/uomlookup.component';
import { SpecificationLookupComponent } from '../../../Lookup/specification-lookup/specification-lookup.component';
import { ProjectBomLookupComponent } from '../../../Lookup/projectbom-lookup/projectbom-lookup.component';
import { ChangeDetectorRef } from '@angular/core';
import { ReportCenterService } from '../../../../services/report-center.service';
import { formatDateDDMMYY } from '../../../../services/formatDateDDMMYY';
import { EmailTemplateService } from '../../../../services/email-template.service';
import { catchError, debounceTime, distinctUntilChanged, EMPTY, forkJoin, map, merge, Observable, of, switchMap } from 'rxjs';
import { CreateQuickProjectComponent } from '../../../Lookup/create-quick-project-lookup/create-quick-project.component';
import { projects } from '../../../../model/inventory.model';
import { CloseQuickPaymentTermsLookupComponent } from '../../../Lookup/close-quick-payment-terms-lookup/close-quick-payment-terms-lookup.component';
import { CloseQuickCustomerLookupComponent } from '../../../Lookup/close-quick-customer-lookup/close-quick-customer-lookup.component';
import { clampDiscountPercent, discountPercentForApi, gstOnNet, lineAmount, lineTotalFromNetAndGst, netFromAmountAndPercent, normalizeDiscountPercentOnLoad, round2,} from '../../../../shared/discount-percent.util';

@Component({
  selector: 'app-create-purchaseorder',
  standalone: true,
  imports: [SharedModule, CommonModule, LoaderComponent],
  templateUrl: './create-purchaseorder.component.html',
  styleUrl: './create-purchaseorder.component.scss'
})

export class CreatePurchaseorderComponent implements OnInit {
  @ViewChild('productCodeInputRef') productCodeInputRef!: any;
  PRStatus: string | undefined;
  status: string | undefined;
  loader: boolean = false;
  selectedProduct: Product[] = [];
  purchaseOrderId: any;
  purchaseOrderLineItemId: any;
  submitted: any;
  warehouseDropdown: any[] = [];
  departmentDropdown: any[] = [];
  filtewarehouse: Warehouse[] = [];
  filterDepartments: Department[] = [];
  filterProductList: any[] = [];
  products: Product[] = [];
  data: Product[] = [];
  manualEntryChecked: boolean = false;
  deleteProductIds: any[] = [];
  previewImage: string = "./assets/no-image.jpg";
  isEditMode: boolean = false;
  addProductData: any;
  allProductData: Product[] = [];
  GSTList: GSTInfo[] = [];
  hsncode: any;
  CGSTtotal: number = 0.00;
  ExtensionPrice: number = 0.00;
  SGSTtotal: number = 0.00;
  IGSTtotal: number = 0.00;
  SalesTaxTotal: number = 0.00;
  orderTotal: number = 0;
  weightTotal: number = 0.00;
  POLineItemData: any;
  TaxTotal: number = 0;
  Taxable: number = 0;
  productCostCalculationType: string | undefined;
  isIGST: boolean = false;
  vendorState: string | undefined;
  warehouseState: string | undefined;
  ShipTocustomerList: any[] = [];
  VendorList: any[] = [];
  selectedCustomerEmail: string | null = null;
  selectedCustomerName: string | null = null;
  userList: any;
  isEditingQuantity: boolean = false;
  isEditingWeight: boolean = false;
  productId: any;
  QAvail: number = 0;
  projectData: any;
  projectBoMId: any;
  statusF: any;
  visible: boolean = false;
  visiblePoAdmin: boolean = false;
  comment: any;
  isPOLimitWarning: boolean = false;
  POLimit: number = 0;
  adminUser: any;
  hide: boolean = false;
  unitLabel: string = '';
  DeptLabel: string = '';
  savePopupVisible: boolean = false;
  saveConfirmVisible: boolean = false
  ReportPath: any;
  companyInfo: any = {};
  vendorName: any;
  vendorEmail: any;
  orderId!: number;
  vendorOutstandingPayables: number | null = null;
  autoSendEmail: boolean = false;
  canSendEmail: boolean = false;
  isSaving: boolean = false;
  userRoles: string[] = [];
  isAdmin: boolean = false;
  isPOAdmin: boolean = false;
  isUser: boolean = false;
  isPoAdminEnabled = false;
  isFormLocked: boolean = false;
  FinalTaxableAmt: number = 0.00;
  updateComment: string = '';
  showUpdateCommentDialog: boolean = false;
  approvePopupVisible: boolean = false;
  canEdit: any;
   moreMenuItems: MenuItem[] = [
    {
      label: 'Linked Files',
      icon: 'pi pi-paperclip',
      command: () => this.openLinkedFiles()
    }
  ];


  constructor(public dialogService: DialogService, public ref: DynamicDialogRef, private warehouseService: AdministratorService,
    private router: Router, private route: ActivatedRoute, private messageService: MessageService, private confirmationService: ConfirmationService,
    private salesService: SalesService, private inventoryService: InventoryService, private customerService: CustomerService, private porderservice: PurchaseorderService,
    private el: ElementRef, private vendorService: VendorService, private routers: ActivatedRoute, private cdr: ChangeDetectorRef, private reportService: ReportCenterService, private emailTemplateService: EmailTemplateService) { }

  private parseDecimal(value: any): number | null {
    if (value === null || value === undefined || value === '') {
      return null;
    }
    return Number(value.toString().replace(/,/g, ''));
  }

  ngOnInit(): void {
    this.purchaseOrderForm.controls.CreatedBy.setValue(localStorage.getItem('username'));
    this.purchaseOrderLineItemForm.controls.CreatedBy.setValue(localStorage.getItem('username'));
    document.title = 'Create Purchase Order';
    this.route.queryParams.subscribe(params => {
      this.orderId = Number(params['orderId']);
    });
    this.getPoAdminSetting();
    // this.getSystemConfigsData();
    this.manualEntry();
    this.getWarehouse(this.pageRequest);
    this.getUserList();
    this.getDepartment(this.pageRequest);
    this.editPurchaseOrder();
    this.startTypingAnimation();
    const currentDate = new Date();
    this.purchaseOrderForm.controls.createdDate.setValue(currentDate);
    this.getGroupIdFromQuery();
    this.getUnitLabel();
    this.getDeptLabel();
    this.getSystemConfigData();
    this.getCompanyDetails();
    const footerFields = [
      this.purchaseOrderForm.get('FreightAmount')?.valueChanges,
      this.purchaseOrderForm.get('GSTRateOnFreight')?.valueChanges,
      this.purchaseOrderForm.get('PackingForwarding')?.valueChanges,
      this.purchaseOrderForm.get('GSTRateOnPNF')?.valueChanges,
    ];

    merge(...footerFields.filter(control => !!control))
      .pipe(
        debounceTime(200),
        distinctUntilChanged()
      )
      .subscribe(() => {
        if (this.loader) return;
        this.calculateFreightGST();
        this.calculatePFGST();
        this.calculateOrderTotal();
      });

  }

  placeholder: string = 'Search By Product ';
  private messages: string[] = [
    'Code',
    'Name',
  ];
  currentMessageIndex: number = 0;
  currentCharIndex: number = 0;
  typingInterval: any;
  waitTimeout: any;

  ngOnDestroy() {
    clearInterval(this.typingInterval);
    clearTimeout(this.waitTimeout);
  }

  startTypingAnimation() {
    this.typingInterval = setInterval(() => {
      if (this.currentCharIndex < this.messages[this.currentMessageIndex].length) {
        this.placeholder += this.messages[this.currentMessageIndex][this.currentCharIndex];
        this.currentCharIndex++;
      } else {
        clearInterval(this.typingInterval);
        this.waitTimeout = setTimeout(() => {

          this.currentCharIndex = 0;
          this.currentMessageIndex = (this.currentMessageIndex + 1) % this.messages.length;
          this.placeholder = 'Search By Product ';
          this.startTypingAnimation();
        }, 1000);
      }
    }, 200);
  }

  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 20,
    id: 0
  }

  purchaseOrderForm = new FormGroup({
    purchaseOrderNumber: new FormControl('', [Validators.required]),
    warehouses: new FormControl(),
    warehouseId: new FormControl(),
    warehouseCode: new FormControl(),
    warehouseName: new FormControl('', Validators.required),
    warehouseAddress: new FormControl(''),
    unitSerial: new FormControl(''),
    requestedDate: new FormControl(new Date(), Validators.required),
    amendmentDate: new FormControl(),
    amendmentNo: new FormControl(),
    poTotal: new FormControl(),
    SGSTtotal: new FormControl(),
    CGSTtotal: new FormControl(),
    IGSTTotal: new FormControl(),
    TaxTotal: new FormControl(),
    vendor: new FormControl(),
    vendorName: new FormControl(''),
    vendorId: new FormControl(),
    vendorCode: new FormControl('', Validators.required),
    add: new FormControl(),
    ShipToCustomerId: new FormControl(),
    ShipToCustomerCode: new FormControl(''),
    ShipToCustomer: new FormControl(''),
    ShipToCustomerAddress: new FormControl(''),
    shipViaCode: new FormControl(),
    departments: new FormControl(),
    departmentId: new FormControl('', Validators.required),
    departmentCode: new FormControl(),
    departmentName: new FormControl('', Validators.required),
    termsCode: new FormControl(),
    specialInstruction: new FormControl(),
    purchaseOrderComment: new FormControl(''),
    totalWeight: new FormControl(),
    isActive: new FormControl(true),
    CreatedBy: new FormControl(),
    manualEntry: new FormControl(false),
    PurchaseOrder_Status: new FormControl('Pending Level 1 Approval'),
    Taxes: new FormControl(''),
    ProjectNo: new FormControl(''),
    // projectBOMCode: new FormControl(''),
    Transport: new FormControl(''),
    Validity: new FormControl(''),
    Delivery: new FormControl(''),
    createdDate: new FormControl<Date | null>(null, Validators.required),
    projectName: new FormControl(''),
    PackingStandard: new FormControl(''),
    Quality: new FormControl(''),
    Insurance: new FormControl(''),
    Freight: new FormControl(''),
    PackingForwarding: new FormControl<number | null>(0, { nonNullable: true }),
    FreightAmount: new FormControl<number | null>(0, { nonNullable: true }),
    projectBoMId: new FormControl(),
    ProductRequisitionId: new FormControl(),
    quoteRefNo: new FormControl(),
    quoteDate: new FormControl(),
    paymentTermsId: new FormControl(),
    FinalTaxableAmt: new FormControl(),
    GSTRateOnPNF: new FormControl(),
    DiscountAmount: new FormControl(),
    GSTOnFreight: new FormControl(),
    GSTOnPNFAmount: new FormControl(),
    GSTRateOnFreight: new FormControl(),
  })

  purchaseOrderLineItemForm = new FormGroup({
    PurchaseOrderNumber: new FormControl(''),
    Quantity: new FormControl(''),
    LineItemNumber: new FormControl(''),
    productId: new FormControl(''),
    productCode: new FormControl(''),
    productDescription: new FormControl(''),
    productQty: new FormControl(''),
    productWgt: new FormControl(''),
    productData: new FormControl(''),
    Cost: new FormControl(''),
    Uom: new FormControl(''),
    AdjustedQuantity: new FormControl(''),
    ExtendedCost: new FormControl(''),
    GSTRate: new FormControl(''),
    CGST: new FormControl(''),
    SGST: new FormControl(''),
    IGST: new FormControl(''),
    Weight: new FormControl(''),
    ImportDuty: new FormControl(''),
    PurchaseOrderComment: new FormControl(''),
    IsActive: new FormControl(''),
    IsSpecialOrder: new FormControl(''),
    CreatedBy: new FormControl(''),
    UpdatedBy: new FormControl(''),
    projectBoMId: new FormControl(),
    projectBoMName: new FormControl(),
    totReqWeight: new FormControl(''),
    totReqQuantity: new FormControl(''),
  })


  setShipTo(data: any) {
    if (data.value) {
      this.purchaseOrderForm.controls.ShipToCustomerCode.setValue(data.value.customerCode);
      this.purchaseOrderForm.controls.ShipToCustomer.setValue(data.value.customerName);
      this.purchaseOrderForm.controls.ShipToCustomerId.setValue(data.value.customerId);
      const address = `${data.value.address.addressLine1}, ${data.value.address.city, data.value.address.state}, ${data.value.address.country} ${data.value.address.zip}`;
      this.purchaseOrderForm.controls.ShipToCustomerAddress.setValue(address);
    }
  }


  autosearchShiptoCustomer(event: any) {
    this.salesService.autoSearchCustomer(event.query).subscribe(
      (data: any) => {
        if (data) {
          this.ShipTocustomerList = data.filter((customer: any) => customer.isShipToCustomer === true);
        } else {
          console.log(data);
        }
      },
      (error: any) => {
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Failed to search ship customer' });
        console.log(error);
      }
    );
  }

  autosearchVendor(event: any) {
    this.vendorService.autoSearchVendor(event.query).subscribe(
      (data: any) => {
        if (data) {
          this.VendorList = data;
        } else {
          console.log(data);
        }
      },
      (error: any) => {
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Failed to search vendor' });
        console.log(error);
      }
    );
  }

  setVendor(data: any) {
    if (data.value) {
      const vendor = data.value;

      this.purchaseOrderForm.patchValue({
        vendorName: vendor.vendorName,
        vendorId: vendor.vendorId,
        vendorCode: vendor.vendorCode,
        add: `${vendor.address?.addressLine1 || ''}, ${vendor.address?.city || ''} ${vendor.address?.state || ''}, ${vendor.address?.country || ''}, ${vendor.address?.zip || ''}`,

        termsCode: vendor.paymentTerms?.termsCode || vendor.termsCode || '',
        paymentTermsId: vendor.paymentTerms?.paymentTermsId || vendor.paymentTermsId || null
      });

      this.vendorState = vendor.address?.state?.trim().toLowerCase() || '';
      this.warehouseState = this.warehouseState?.trim().toLowerCase() || '';

      this.isIGST = this.vendorState !== this.warehouseState;

      this.calculateOrderTotal();

      this.selectedCustomerEmail = vendor.email;
      this.selectedCustomerName = vendor.vendorName;
    }
  }

  formatAddress(address: any): string {
    if (!address) return '';

    return [
      address.addressLine1,
      address.city,
      address.state,
      address.country,
      address.zip
    ]
      .filter(Boolean) // remove null/undefined/empty
      .join(', ');
  }


  openShipToCustomerLookup() {
    const ref = this.dialogService.open(ShipToCustomerLookupComponent, {
      header: 'Ship To Customer List',
      width: '80%'
    });

    ref.onClose.subscribe((selectedCustomer: any) => {
      if (selectedCustomer) {
        this.purchaseOrderForm.controls.ShipToCustomerId.setValue(selectedCustomer.customerId);
        this.purchaseOrderForm.controls.ShipToCustomerCode.setValue(selectedCustomer.customerCode);
        this.purchaseOrderForm.controls.ShipToCustomer.setValue(selectedCustomer.customerName);
        const address = `${selectedCustomer.address.addressLine1}, ${selectedCustomer.address.city, selectedCustomer.address.state}, ${selectedCustomer.address.country} ${selectedCustomer.address.zip}`;
        this.purchaseOrderForm.controls.ShipToCustomerAddress.setValue(address);
      }
    });
  }

  performAction(action: any, sendEmail: boolean = false) {
    const data = this.purchaseOrderForm?.value;

    if (data) {
      data.ProductRequisitionId = this.orderId;

      if (this.isEditMode) {
        // Handle 'Submit' action
        if (action === 'Submit') {

          if (this.orderTotal > this.POLimit && this.adminUser !== 'Admin') {
            this.messageService.add({
              severity: 'error',
              summary: 'Warning',
              detail: 'PO amount exceeds the threshold. Contact your administrator to proceed.'
            });
            return;
          }

          if (this.adminUser !== 'Admin') {
            this.messageService.add({
              severity: 'error',
              summary: 'Unauthorized',
              detail: 'You are not authorized to submit PO. Contact your administrator to proceed.'
            });
            return;
          }

          //data.PurchaseOrder_Status = 'Ready';
          data.PurchaseOrder_Status = 'Approved';
          this.updatePO(data, sendEmail);
        }

        // Handle 'Save' action
        if (action === 'Save') {
          data.PurchaseOrder_Status = 'Pending Level 1 Approval';
          this.updatePO(data, sendEmail);
        }
      } else {
        // Create a new Purchase Order if not in edit mode
        this.createPO(data);
      }
    } else {
      // Optionally handle the case where data is null or undefined
      console.error("Form data is null or undefined");
    }
  }


  async createPO(data: any) {
    this.submitted = true;
    if (!this.validateForm()) return;

    if (this.products.length < 1) {
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please enter product.' });
      const el = this.el.nativeElement.querySelector('[formControlName="productCode"]');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    for (const product of this.products) {
      const validProductId = product.ProductId || this.productId;
      if (!validProductId) {
        this.messageService.add({ severity: 'error', summary: 'Invalid Product', detail: 'Product ID is missing.' });
        return;
      }
      if (!product.ProductDescription) {
        this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'Product Name is Required' });
        return;
      }
      try {
        const productData = await this.getProductById(validProductId);
        const costCalculationType = productData.costCalculation || 'Qty';

        if (costCalculationType === 'Qty' && product.POQuantity <= 0) {
          this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'POQuantity must be greater than 0.' });
          return;
        } else if (costCalculationType === 'Wgt' && product.Weight <= 0) {
          this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'Weight must be greater than 0.' });
          return;
        }
      } catch (error) {
        this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Failed to fetch product metadata.' });
        return;
      }
    }

    this.loader = true;
    const currentTime = new Date();

    const toISTISO = (dateObj: Date) => {
      const offset = dateObj.getTimezoneOffset() * 60000;
      return new Date(dateObj.getTime() - offset).toISOString();
    };

    try {
      const dateFields = ['requestedDate', 'createdDate', 'amendmentDate', 'quoteDate'];
      dateFields.forEach(field => {
        if (data[field]) {
          const d = new Date(data[field]);
          d.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
          data[field] = d;
        }
      });

      if (data.requestedDate && data.createdDate) {
        if (new Date(data.requestedDate).setHours(0, 0, 0, 0) < new Date(data.createdDate).setHours(0, 0, 0, 0)) {
          this.loader = false;
          this.messageService.add({ severity: 'error', summary: 'Invalid Date Range', detail: 'Requested date cannot be earlier than order date.' });
          return;
        }
      }

      dateFields.forEach(field => {
        if (data[field]) data[field] = toISTISO(data[field]);
      });


      const createPOResponse = await this.porderservice.createPurchaseOrder(data).toPromise();
      if (createPOResponse) {
        const finalPONumber = createPOResponse.purchaseOrderNumber || data.purchaseOrderNumber;

        const itemsWithPo = this.products.map((item: any) => ({
          ...item,
          PurchaseOrderNumber: finalPONumber
        }));

        await this.createPOrderLineItem(itemsWithPo);
      }
    } catch (error) {
      console.error('Error creating PO:', error);
      this.loader = false;
      this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Failed To Create Purchase Order.' });
    }
  }

  async createPOrderLineItem(data: any[]) {
    this.loader = true;

    const delay = (ms: number) => new Promise(res => setTimeout(res, ms));

    const toISTISO = (date: any) => {
      if (!date) return null;
      const d = new Date(date);
      const offset = d.getTimezoneOffset() * 60000;
      return new Date(d.getTime() - offset).toISOString();
    };

    try {
      for (let i = 0; i < data.length; i++) {

        const item = data[i];

        const productData = {
          ...item,

          LineItemNumber: i + 1,

          NetAmount: Number(item.NetAmount || 0),
          LineTotal: Number(item.LineTotal || 0),

          Discount: this.discountRupeesForLineItemApi(item),
          ExtendedCost: Number(item.ExtendedCost || 0),

          CGST: Number(item.CGST || 0),
          SGST: Number(item.SGST || 0),
          IGST: Number(item.IGST || 0),

          DateRequired: item.DateRequired
            ? toISTISO(new Date(item.DateRequired))
            : null
        };

        try {
          await this.porderservice.createPurchaseOrderLineItem(productData).toPromise();

          await this.updateInventory(productData);

          await delay(150);

        } catch (lineError) {
          console.error(`Error at Line Item index ${i}:`, lineError);
          throw lineError;
        }
      }

      this.loader = false;

      this.messageService.add({
        severity: 'success',
        summary: 'Success',
        detail: 'Purchase Order Saved Successfully.'
      });

      setTimeout(() => {
        this.router.navigate(['/home/listPurchaseOrders']);
      }, 1000);

    } catch (error) {
      this.loader = false;

      this.messageService.add({
        severity: 'error',
        summary: 'Failed',
        detail: 'Line item creation failed.'
      });
    }
  }

  updateInventory(ProductData: any) {
    this.loader = true;
    const data = this.purchaseOrderForm.value;

    const productId = ProductData.ProductId || this.productId;

    const Inventory: UpdateInventory = <UpdateInventory>{
      productId: productId,
      warehouseId: data.warehouseId,
      productCode: ProductData.ProductCode,
      status: "CreatePO",
      transactionType: "",
      transactionNo: "",
      quantity: ProductData.POQuantity,
      uom: ProductData.Uom,
      createdBy: localStorage.getItem('username'),
      transactionDate: new Date(),
      createdDate: new Date(),
    }

    // console.log(Inventory);
    this.inventoryService.updateInventory(Inventory).subscribe({
      next: (data: any) => {
        // console.log(data);
      },
      error: error => {
        console.log(error);
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error occurred while updating PO in Inventory.' });
        this.loader = false;
        return;
      }
    });


  }

  async updatePO(data: any, sendEmail: boolean = false) {
    this.submitted = true;
    if (!this.validateForm()) return;

    if (this.products.length < 1) {
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please enter at least one product.' });
      const productCodeElement = this.el.nativeElement.querySelector('[formControlName="productCode"]');
      if (productCodeElement) productCodeElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    const currentTime = new Date();
    if (data.requestedDate && data.createdDate) {
      const reqDate = new Date(data.requestedDate).setHours(0, 0, 0, 0);
      const ordDate = new Date(data.createdDate).setHours(0, 0, 0, 0);
      if (reqDate < ordDate) {
        this.messageService.add({ severity: 'error', summary: 'Invalid Date', detail: 'Requested date cannot be earlier than order date.' });
        return;
      }
    }

    for (const p of this.products) {
      if (p.Cost < 0) {
        this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'Price cannot be negative.' });
        return;
      }
    }

    this.loader = true;
    const currentUser = localStorage.getItem('username') || '';

    const toISTISO = (date: any) => {
      if (!date) return null;
      const d = new Date(date);
      const offset = d.getTimezoneOffset() * 60000;
      return new Date(d.getTime() - offset).toISOString();
    };

    try {
      if (this.deleteProductIds && this.deleteProductIds.length > 0) {
        for (const id of this.deleteProductIds) {
          const item = this.data.find(p => p.purchaseOrderLineItemId === id);
          if (item) {
            const invData: UpdateInventory = {
              productId: item.ProductId,
              warehouseId: data.warehouseId || 0,
              productCode: item.ProductCode,
              status: "DeletePO",
              transactionType: "",
              transactionNo: data.purchaseOrderNumber || '',
              quantity: item.POQuantity,
              createdBy: currentUser,
              transactionDate: new Date(),
              createdDate: new Date()
            };
            await this.inventoryService.updateInventory(invData).toPromise();
            await this.porderservice.deletePurchaseOrderLineitem([id]).toPromise();
          }
        }
      }

      let currentMaxLine = this.products.reduce((max, p) => Math.max(max, p.LineItemNumber || 0), 0);

      for (const product of this.products) {
        product.PurchaseOrderNumber = data.purchaseOrderNumber;

        if (product.DateRequired) {
          product.DateRequired = new Date(product.DateRequired);
          product.DateRequired.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());
        }

        if (product.purchaseOrderLineItemId) {
          product.UpdatedBy = currentUser;
          const linePayload = {
            ...product,
            Discount: this.discountRupeesForLineItemApi(product)
          };
          await this.porderservice.updatePurchaseOrderLineitem(linePayload).toPromise();
          await this.updateInventory(product);
        } else {
          currentMaxLine++;
          product.LineItemNumber = currentMaxLine;
          product.CreatedBy = currentUser;
          product.IsActive = true;
          const linePayload = {
            ...product,
            Discount: this.discountRupeesForLineItemApi(product)
          };
          const saved: any = await this.porderservice.createPurchaseOrderLineItem(linePayload).toPromise();
          product.purchaseOrderLineItemId = saved?.purchaseOrderLineItemId;
          await this.updateInventory(product);
        }
      }
      const poHeader = { ...data };
      poHeader.purchaseOrderId = this.purchaseOrderId;
      poHeader.UpdatedBy = currentUser;

      const dateFields = ['createdDate', 'requestedDate', 'amendmentDate', 'quoteDate'];
      dateFields.forEach(f => { if (poHeader[f]) poHeader[f] = toISTISO(poHeader[f]); });

      const decimals = ['DiscountAmount', 'FreightAmount', 'PackingForwarding', 'TaxTotal', 'TotalWeight', 'FinalTaxableAmt', 'CGSTTotal', 'SGSTTotal', 'IGSTTotal'];
      decimals.forEach(f => poHeader[f] = this.parseDecimal(poHeader[f] ?? 0));

      poHeader.POTotal = this.parseDecimal(data.poTotal ?? 0);
      delete poHeader.poTotal;
      delete poHeader.vendor;
      delete poHeader.warehouses;

      this.porderservice.updatePurchaseOrder(poHeader).subscribe({
        next: (res: any) => {
          this.loader = false;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'PO Updated Successfully.' });

          if (sendEmail) {
            this.sendOrderEmail(res, () => {
              this.router.navigate(['/home/listPurchaseOrders']);
            });
          } else {
            setTimeout(() => {
              this.router.navigate(['/home/listPurchaseOrders']);
            }, 1000);
          }
        },
        error: () => {
          this.loader = false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Database error occurred during final save.' });
        }
      });

    } catch (error) {
      this.loader = false;
      console.error('Process Error:', error);
      this.messageService.add({ severity: 'error', summary: 'Transaction Failed', detail: 'A database conflict (Deadlock) occurred. Please try again.' });
    }
  }
  createPOrder(data: any) {
    this.porderservice.createPurchaseOrder(data).subscribe({
      next: (data: any) => {
        this.createPOrderLineItem(this.products)
      },
      error: error => {
        console.log(error);
      }
    });
  }

  private discountRupeesForLineItemApi(item: any): number {
    return discountPercentForApi(item);
  }

  updatePOrder(data: any) {
    data.purchaseOrderId = this.purchaseOrderId
    if (data) {
      this.porderservice.updatePurchaseOrder(data).subscribe({
        next: responseData => {
          this.createPOrderLineItem(this.products)
          this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Purchase Order Updated Successfully.' });
          this.router.navigate(['/home/listPurchaseOrders']);
        },
        error: error => {
          console.error('Error updating PurchaseOrders:', error);
        }
      });
    } else {
      this.createPOrder(data);
    }
  }

  updatePOrderLineItem(data: any) {
    if (data) {
      // Ensure DateRequired has current hours, minutes, seconds
      const currentTime = new Date();
      if (data.DateRequired) {
        data.DateRequired.setHours(
          currentTime.getHours(),
          currentTime.getMinutes(),
          currentTime.getSeconds()
        );
      } else {
        data.DateRequired = currentTime;
      }

      // Create the object to send to service
      const updateObj = {
        purchaseOrderLineItemId: data.purchaseOrderLineItemId,
        PurchaseOrderNumber: data.PurchaseOrderNumber,
        LineItemNumber: data.LineItemNumber,
        ProductId: data.ProductId,
        ProductCode: data.ProductCode,
        ProductDescription: data.ProductDescription,
        ProductSpecification: data.ProductSpecification,
        POQuantity: data.POQuantity,
        ReceivedQuantity: data.ReceivedQuantity,
        Uom: data.Uom,
        Cost: data.Cost,
        ExtendedCost: data.ExtendedCost,
        GSTRate: data.GSTRate,
        CGST: data.CGST,
        SGST: data.SGST,
        IGST: data.IGST,
        IsActive: data.IsActive,
        IsTaxable: data.IsTaxable,
        Weight: data.Weight,
        DateRequired: data.DateRequired,
        Comment: data.Comment,
        projectBoMId: data.projectBoMId,
        projectName: data.projectName,
        HSNCode: data.HSNCode,
        UnitPrice: data.UnitPrice ?? 0,
        Discount: this.discountRupeesForLineItemApi(data)
      };

      this.porderservice.updatePurchaseOrderLineitem(updateObj).subscribe({
        next: res => {
          console.log('Purchase Order Lineitem Updated Successfully.', res);
          // Optional: show message
          // this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Purchase Order Lineitem Updated Successfully.' });
        },
        error: error => {
          console.error('Error updating PurchaseOrders:', error);
        }
      });
    } else {
      this.createPOrderLineItem(data);
    }
  }

  deletePOLineitem() {
    this.confirmationService.confirm({
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      message: 'Do you want to delete?',
      accept: () => {

        var selectedProductIds: any
        this.data = this.selectedProduct;
        if (!this.isEditMode) {

          selectedProductIds = this.selectedProduct.map(product => product.LineItemNumber);
          this.products = this.products.filter(product => !selectedProductIds.includes(product.LineItemNumber));
          this.selectedProduct = [];
          this.calculateOrderTotal();

        } else {
          this.deleteProductIds.push(
            ...this.selectedProduct
              .map(product => product.purchaseOrderLineItemId)
              .filter(id => {
                return id && id.toString().trim() !== '';
              })
          );

          selectedProductIds = this.selectedProduct.map(product => product.LineItemNumber);
          this.products = this.products.filter(product => !selectedProductIds.includes(product.LineItemNumber));
          this.selectedProduct = [];
          this.calculateOrderTotal();
        }

      },
      reject: () => {
        // Do nothing if user rejects deletion
      }
    });
  }


  getWarehouse(query: gridPageRequest) {
    this.warehouseService.getAllWarehouse(query).subscribe({
      next: (data: any) => {
        this.warehouseDropdown = data.warehouses;
      }
    });
  }

  filteWarehouse(event: any) {
    let filtered: any[] = [];
    let query = event.query;

    for (let i = 0; i < (this.warehouseDropdown as any[]).length; i++) {
      let warehouses = (this.warehouseDropdown as any[])[i];
      if (warehouses.warehouseCode.toLowerCase().indexOf(query.toLowerCase()) == 0 ||
        warehouses.warehouseName.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(warehouses);
      }
    }
    this.filtewarehouse = filtered;
  }

  SelectedWarehouse(event: any) {
    if (event && event.value) {
      const selectedWarehouse = event.value;
      this.purchaseOrderForm.controls['warehouseCode'].setValue(selectedWarehouse.warehouseCode);
      this.purchaseOrderForm.controls['warehouseId'].setValue(selectedWarehouse.warehouseId);
      this.purchaseOrderForm.controls['warehouseName'].setValue(selectedWarehouse.warehouseName);
      this.purchaseOrderForm.controls['unitSerial'].setValue(selectedWarehouse.unitSerial);  // Set unitSerial
      this.warehouseState = selectedWarehouse.address.state;
      const address = `${selectedWarehouse.address.addressLine1} , ${selectedWarehouse.address.city} , ${selectedWarehouse.address.state} , ${selectedWarehouse.address.country} , ${selectedWarehouse.address.zip}`;
      this.purchaseOrderForm.controls.warehouseAddress.setValue(address);
      if (!this.purchaseOrderForm.controls.manualEntry.value) {
        this.getManualEntry();
      }
    }
  }


  getVendor() {
    if (!this.warehouseState) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please select a unit state first' });
      return;
    }

    this.ref = this.dialogService.open(VendorLookupComponent, {
      header: 'Vendor List',
      width: '60%',
    });
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.purchaseOrderForm.patchValue({
          vendorName: data.vendorName,
          vendorId: data.vendorId,
          vendorCode: data.vendorCode,
          add: `${data.address.addressLine1},${data.address.city} ${data.address.state}, ${data.address.country},${data.address.zip}`,
          termsCode: data.termsCode,
          paymentTermsId: data.paymentTermsId
        });

        this.vendorState = data.address.state?.trim().toLowerCase();
        this.warehouseState = this.warehouseState?.trim().toLowerCase();

        this.isIGST = this.vendorState !== this.warehouseState;

        // Now run calculation
        this.calculateOrderTotal();

        this.selectedCustomerEmail = data.email;
        this.selectedCustomerName = data.vendorName;
        this.vendorEmail = data.email;

      }

    });
  }

  getTermsCode() {
    this.ref = this.dialogService.open(TermscodeLookupComponent, {
      header: 'Terms Code',
      width: '80%',
    })
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.purchaseOrderForm.patchValue({
          termsCode: data.paymentTermsDescription,
          paymentTermsId: data.paymentTermsId
        })
      }
    })
  }

  getDepartment(query: gridPageRequest) {
    this.porderservice.getDepartment(query).subscribe({
      next: (data: any) => {
        this.departmentDropdown = data.department;
        if (!this.isEditMode) {
          if (data.department) {
            this.purchaseOrderForm.controls['departmentCode'].setValue(data.department[0].departmentCode);
            this.purchaseOrderForm.controls['departmentId'].setValue(data.department[0].departmentId);
            this.purchaseOrderForm.controls['departmentName'].setValue(data.department[0].departmentName);
          }
        }
      }
    });
  }

  filterDepartment(event: any) {
    let filtered: any[] = [];
    let query = event.query;
    for (let i = 0; i < (this.departmentDropdown as any[]).length; i++) {
      let departments = (this.departmentDropdown as any[])[i];
      if (departments.departmentCode.toLowerCase().indexOf(query.toLowerCase()) == 0 ||
        departments.departmentName.toLowerCase().indexOf(query.toLowerCase()) === 0) {
        filtered.push(departments);
      }
    }
    this.filterDepartments = filtered;
  }

  SelectedDepartment(event: any) {
    if (event && event.value) {
      const SelectedDepartment = event.value;
      this.purchaseOrderForm.controls['departmentCode'].setValue(SelectedDepartment.departmentCode);
      this.purchaseOrderForm.controls['departmentId'].setValue(SelectedDepartment.departmentId);
      this.purchaseOrderForm.controls['departmentName'].setValue(SelectedDepartment.departmentName);
    }
  }

  manualEntry() {
    if (!this.isEditMode) {
      const manualEntryValue = this.purchaseOrderForm.controls.manualEntry.value;
      this.manualEntryChecked = manualEntryValue === true;

      if (this.manualEntryChecked) {
        this.purchaseOrderForm.controls.purchaseOrderNumber.setValue('');
      } else {
        this.getManualEntry();
      }
    }
  }

  getManualEntry() {
    this.loader = true;
    const unitSerial = this.purchaseOrderForm.controls['unitSerial'].value;

    if (!unitSerial) {
      this.loader = false;
      this.messageService.add({
        severity: 'error',
        summary: 'Error',
        detail: 'Unit Serial is required to generate the PO number.'
      });
      return;
    }

    this.porderservice.getAutogeneratedPoNumber(unitSerial).subscribe(
      (data: any) => {
        this.loader = false;
        // const alphanumericCode = 'PO';
        // const projectCode = `${unitSerial}${alphanumericCode}${data}`;
        const projectCode = `${unitSerial}${data}`;

        this.purchaseOrderForm.patchValue({
          purchaseOrderNumber: projectCode,
        });
      },
      error => {
        console.error(error);
        this.loader = false;
      }
    );
  }


  get formControls() {
    return this.purchaseOrderForm.controls;
  }

  reset() {
    this.purchaseOrderForm.reset();
  }

  Cancel() {
    this.router.navigate(['/home/listPurchaseOrders']);
  }

  validateForm() {
    let isValid = true;
    if (this.purchaseOrderForm.invalid) {
      this.messageService.add({ severity: 'warn', summary: 'Warning', detail: 'Please fill Required field' })
      isValid = false;
    }
    return isValid;
  }

  setProduct(data: any) {
    this.purchaseOrderLineItemForm.controls.productCode.setValue(data.value.productCode);
    this.purchaseOrderLineItemForm.controls.productDescription.setValue(data.value.productName);
    this.purchaseOrderLineItemForm.controls.productId.setValue(data.value.productId);
    this.addProductData = data.value;

    const costCalculationType = data.value.costCalculation;
    this.productCostCalculationType = costCalculationType || 'Qty';

    if (costCalculationType === 'Qty') {
      this.purchaseOrderLineItemForm.controls.productQty.setValue('');
    } else if (costCalculationType === 'Wgt') {
      this.purchaseOrderLineItemForm.controls.productWgt.setValue('');
    }
    this.setFieldFocus();

    if (data.value.productImage) {
      this.previewImage = `data:image/jpeg;base64,${data.value.productImage}`;
    } else {
      this.previewImage = "./assets/no-image.jpg";
    }
    this.getInventoryStatus(data.value.productCode);
  }

  setFieldFocus() {
    const control = this.el.nativeElement.querySelector('#Qty');
    if (control) {
      setTimeout(() => {
        control.focus();
      }, 100);
    }
  }

  autosearchProduct(event: any) {
    this.salesService.autoSearchProduct(event.query).subscribe(
      (data: any) => {
        if (data) {
          this.filterProductList = data;
        } else {
        }
      },
      (error: any) => {
      }
    );
  }

  async addProduct() {
    this.loader = true;
    this.submitted = true;

    // Validate customer
    const isValid = this.validateCustomer();
    let success = await this.checkIGST();

    if (!success || !isValid) {
      window.scroll(0, 0);
      this.loader = false;
      return;
    }

    const productId = _.toNumber(this.purchaseOrderLineItemForm.controls.productId.value);

    this.inventoryService.getProductById(productId).subscribe({
      next: (productData: any) => {

        // Prepare product data
        this.addProductData = {
          ...this.addProductData,
          productName: productData.productName || this.addProductData.productName,
          standardCost: productData.standardCost || this.addProductData.standardCost,
          productCode: productData.productCode || this.addProductData.productCode,
          hsnCode: productData.hsnCode || this.addProductData.hsnCode,
          gst: productData.gstRate || this.addProductData.gstRate,
        };
        const costCalculationType = productData.costCalculation || 'Qty';

        const lastItem = this.allProductData[this.allProductData.length - 1];
        const orderQuantity = _.toNumber(this.purchaseOrderLineItemForm.controls.productWgt.value);
        const weight = _.toNumber(this.purchaseOrderLineItemForm.controls.productWgt.value);
        const parseCurrency = (value: any): number => {
          return parseFloat((value ?? 0).toString().replace(/[₹,]/g, ''));
        };
        const salesPrice = parseCurrency(this.addProductData?.salesPrice);
        const standardCost = parseCurrency(this.addProductData?.standardCost);
        let extendedCost: number;

        if (costCalculationType === 'Qty') {
          extendedCost = orderQuantity * standardCost;
        } else if (costCalculationType === 'Wgt') {
          extendedCost = weight * standardCost;
        } else {
          console.warn('Unknown costCalculation type:', costCalculationType);
          extendedCost = 0;
        }

        const requestedDate: any = this.purchaseOrderForm.controls.requestedDate.value;
        const currentTime = new Date();
        requestedDate.setHours(currentTime.getHours(), currentTime.getMinutes(), currentTime.getSeconds());

        const gstRate = this.addProductData.gst != null ? this.addProductData.gst : 0;
        const projectBoMId = this.purchaseOrderLineItemForm.controls.projectBoMId.value;
        const projectName = this.purchaseOrderLineItemForm.controls.projectBoMName?.value || ''; // make sure your form has projectName

        const product: Product = <Product><unknown>{
          PurchaseOrderNumber: _.toString(this.purchaseOrderForm.controls.purchaseOrderNumber.value),
          ProductId: productId,
          POQuantity: costCalculationType === 'Wgt' ? 0 : orderQuantity,
          ReceivedQuantity: 0,
          projectBoMId: projectBoMId,
          projectName: projectName,
          Uom: this.addProductData.purchasingUom,
          LineItemNumber: this.products.length > 0
            ? Math.max(...this.products.map(p => p.LineItemNumber || 0)) + 1 : 1,
          IsTaxable: this.addProductData.isTaxable,
          HSNCode: this.addProductData.hsnCode,
          Cost: standardCost,
          Discount: 0,
          TotalDiscount: 0,
          Weight: costCalculationType === 'Qty' ? 0 : weight,
          GSTRate: gstRate,
          ExtendedCost: extendedCost,
          Comment: "",
          ProductSpecification: this.addProductData.productSpecification,
          DateRequired: requestedDate,

          CGST: (!this.isIGST && costCalculationType === 'Qty')
            ? this.calculateGST(standardCost, orderQuantity, gstRate, this.addProductData.isTaxable) / 2
            : (!this.isIGST && costCalculationType === 'Wgt')
              ? this.calculateGST(standardCost, weight, gstRate, this.addProductData.isTaxable) / 2
              : 0,

          SGST: (!this.isIGST && costCalculationType === 'Qty')
            ? this.calculateGST(standardCost, orderQuantity, gstRate, this.addProductData.isTaxable) / 2
            : (!this.isIGST && costCalculationType === 'Wgt')
              ? this.calculateGST(standardCost, weight, gstRate, this.addProductData.isTaxable) / 2
              : 0,

          IGST: (this.isIGST && costCalculationType === 'Qty')
            ? this.calculateGST(standardCost, orderQuantity, gstRate, this.addProductData.isTaxable)
            : (this.isIGST && costCalculationType === 'Wgt')
              ? this.calculateGST(standardCost, weight, gstRate, this.addProductData.isTaxable)
              : 0,
          ProductCode: this.addProductData.productCode,
          ProductDescription: this.addProductData.productName,
          CreatedBy: _.toString(this.purchaseOrderLineItemForm.controls.CreatedBy.value),
          IsActive: true,
        };
        this.products.push({ ...product });
        // this.allProductData.push({ ...product });

        this.purchaseOrderLineItemForm.controls.productCode.setValue('');
        this.purchaseOrderLineItemForm.controls.productDescription.setValue('');
        this.purchaseOrderLineItemForm.controls.productQty.setValue('');
        this.purchaseOrderLineItemForm.controls.productWgt.setValue('');

        this.loader = false;
        this.calculateOrderTotal();
        this.previewImage = "./assets/no-image.jpg";
        this.QAvail = 0;

        setTimeout(() => {
          const inputEl: HTMLInputElement = this.productCodeInputRef?.el?.nativeElement?.querySelector('input');
          inputEl?.focus();
        }, 0);

      },
      error: (error: any) => {
        console.error('Error fetching product data:', error);
        this.loader = false;
      }
    });
  }

  getProductById(productId: number): Promise<any> {
    return new Promise((resolve, reject) => {
      this.inventoryService.getProductById(this.productId || productId).subscribe({
        next: (data: any) => resolve(data),
        error: (error) => reject(error),
      });
    });
  }

  async onProductEdit(event: any) {
    const editData = event;
    const index = this.products.findIndex(p => p.LineItemNumber === editData.LineItemNumber);
    if (index === -1) return;

    const getNum = (v: any) => Number(v) || 0;
    const qty = getNum(editData.POQuantity);
    const cost = getNum(editData.Cost);
    const discPct = clampDiscountPercent(getNum(editData.Discount));
    const gstRate = getNum(editData.GSTRate);
    const amount = lineAmount(qty, cost);

    if (discPct > 100) {
      this.messageService.add({
        severity: 'error',
        summary: 'Invalid Discount',
        detail: 'Discount % cannot exceed 100.'
      });
      return;
    }

    const netAmount = netFromAmountAndPercent(amount, discPct);
    const gstSplit = gstOnNet(netAmount, gstRate, this.isIGST, editData.IsTaxable);
    const lineTotal = lineTotalFromNetAndGst(netAmount, gstSplit);

    this.products[index] = {
      ...editData,
      ExtendedCost: round2(amount),
      Discount: discPct,
      NetAmount: netAmount,
      CGST: gstSplit.cgst,
      SGST: gstSplit.sgst,
      IGST: gstSplit.igst,
      LineTotal: lineTotal
    };

    void this.calculateOrderTotal();

    if (editData.purchaseOrderLineItemId) {
      this.updatePOrderLineItem(this.products[index]);
    }
  }



  // Function to check IGST based on warehouse and vendor states
  checkIGST() {
    //console.log('warehouseState:', this.warehouseState, 'vendorState:', this.vendorState);
    if (!this.warehouseState || !this.vendorState) {
      this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Failed to calculate IGST due to missing state values' });
      return false;
    }

    if (this.warehouseState === this.vendorState) {
      this.isIGST = false;
    } else {
      this.isIGST = true;
    }
    return true;
  }



  calculateGST(price: number, POQuantity: number, gstrate: number, taxable: boolean): number {
    if (taxable === true) {
      const gst = (price * POQuantity) * gstrate / 100;
      return gst;
    }
    else {
      return 0;
    }
  }

  async calculateOrderTotal() {
    let cgst = 0, sgst = 0, igst = 0;
    let taxable = 0;
    let quantityTotal = 0;

    const getNum = (val: any) => _.toNumber(val) || 0;
    const parseCurrency = (val: any) =>
      parseFloat((val ?? 0).toString().replace(/[₹,]/g, '') || '0');

    const freightCharge = getNum(this.purchaseOrderForm.get('FreightAmount')?.value);
    const pfCharge = getNum(this.purchaseOrderForm.get('PackingForwarding')?.value);
    const freightGSTRate = getNum(this.purchaseOrderForm.get('GSTRateOnFreight')?.value);
    const pfGSTRate = getNum(this.purchaseOrderForm.get('GSTRateOnPNF')?.value);

    for (let i = 0; i < this.products.length; i++) {
      const product = this.products[i];
      const qty = getNum(product.POQuantity);
      const cost = parseCurrency(product.Cost);
      const discPct = clampDiscountPercent(getNum(product.Discount));
      const gross = lineAmount(qty, cost);
      const netAmount = netFromAmountAndPercent(gross, discPct);
      taxable += netAmount;

      const gstSplit = gstOnNet(netAmount, getNum(product.GSTRate), this.isIGST, product.IsTaxable);
      if (this.isIGST) {
        igst += gstSplit.gstTotal;
      } else {
        cgst += gstSplit.cgst;
        sgst += gstSplit.sgst;
      }

      const lineTotal = lineTotalFromNetAndGst(netAmount, gstSplit);

      this.products[i].ExtendedCost = round2(gross);
      this.products[i].Discount = discPct;
      this.products[i].NetAmount = netAmount;
      this.products[i].LineTotal = lineTotal;
      this.products[i].CGST = gstSplit.cgst;
      this.products[i].SGST = gstSplit.sgst;
      this.products[i].IGST = gstSplit.igst;

      quantityTotal += qty;
    }

    const freightGST = _.round((freightCharge * freightGSTRate) / 100, 2);
    const pfGST = _.round((pfCharge * pfGSTRate) / 100, 2);
    const extraGST = freightGST + pfGST;

    if (extraGST > 0) {
      if (this.isIGST) { igst += extraGST; }
      else { cgst += extraGST / 2; sgst += extraGST / 2; }
    }

    this.purchaseOrderForm.patchValue({ DiscountAmount: 0 }, { emitEvent: false });

    this.CGSTtotal = this.isIGST ? 0 : _.round(cgst, 2);
    this.SGSTtotal = this.isIGST ? 0 : _.round(sgst, 2);
    this.IGSTtotal = this.isIGST ? _.round(igst, 2) : 0;
    this.TaxTotal = this.CGSTtotal + this.SGSTtotal + this.IGSTtotal;

    this.FinalTaxableAmt = _.round(taxable + freightCharge + pfCharge, 2);
    this.orderTotal = _.round(this.FinalTaxableAmt + this.TaxTotal, 2);
    this.weightTotal = _.round(quantityTotal, 2);
    this.Taxable = _.round(taxable, 2);

    this.POLineItemData = _.cloneDeep(this.products);

    this.purchaseOrderForm.patchValue({
      poTotal: this.orderTotal,
      SGSTtotal: this.SGSTtotal,
      CGSTtotal: this.CGSTtotal,
      IGSTTotal: this.IGSTtotal,
      TaxTotal: this.TaxTotal,
      totalWeight: this.weightTotal,
      FinalTaxableAmt: this.FinalTaxableAmt
    }, { emitEvent: false });

    this.products = [...this.products];

    return true;
  }


  validateCustomer() {
    let isValid = true;
    if (!this.purchaseOrderForm.controls.purchaseOrderNumber?.valid ||
      // !this.purchaseOrderForm.controls.warehouseCode.value ||
      !this.purchaseOrderForm.controls.warehouseId.value ||
      !this.purchaseOrderForm.controls.vendorCode.value
    ) {
      this.messageService.add({ severity: 'error', summary: 'Warning', detail: 'Please fill Required field' });
      isValid = false;
    }
    return isValid;
  }

  editPurchaseOrder() {
    this.route.queryParams.subscribe(params => {
      this.purchaseOrderId = params['purchaseOrderId'];
      this.isEditMode = !!this.purchaseOrderId;

      if (this.isEditMode) {
        this.loader = true;

        this.porderservice.getPurchaseOrderById(this.purchaseOrderId).subscribe(
          (purchaseOrder: any) => {
            if (purchaseOrder) {
              this.loader = false;
              document.title = 'Update Purchase Order';
              const requestedDate = new Date(purchaseOrder.requestedDate);
              const createdDate = new Date(purchaseOrder.createdDate);
              const amendmentDate = purchaseOrder.amendmentDate ? new Date(purchaseOrder.amendmentDate) : null;
              const quoteDate = purchaseOrder.quoteDate ? new Date(purchaseOrder.quoteDate) : null;

              const formPatch: any = {
                ...purchaseOrder,
                departments: purchaseOrder.department?.departmentCode,
                PurchaseOrder_Status: purchaseOrder.purchaseOrder_Status,
                departmentName: purchaseOrder.department?.departmentName,
                warehouses: purchaseOrder.warehouse?.warehouseCode,
                warehouseName: purchaseOrder.warehouse?.warehouseName,
                ShipToCustomerCode: purchaseOrder.shipToCustomerCode,
                ShipToCustomerId: purchaseOrder.shipToCustomerId,
                vendorName: purchaseOrder.vendor?.vendorName,
                add: `${purchaseOrder.vendor?.address?.addressLine1 || ''}, ${purchaseOrder.vendor?.address?.city || ''}, ${purchaseOrder.vendor?.address?.state || ''}, ${purchaseOrder.vendor?.address?.country || ''}, ${purchaseOrder.vendor?.address?.zip || ''}`,
                requestedDate: requestedDate,
                createdDate: createdDate,
                amendmentDate: amendmentDate,
                quoteDate: quoteDate,
                termsCode: purchaseOrder.termsCode,
                warehouseCode: purchaseOrder.warehouse?.warehouseCode,
                warehouseAddress: `${purchaseOrder.warehouse?.address?.addressLine1 || ''}, ${purchaseOrder.warehouse?.address?.city || ''}, ${purchaseOrder.warehouse?.address?.state || ''}, ${purchaseOrder.warehouse?.address?.country || ''}, ${purchaseOrder.warehouse?.address?.zip || ''}`,
                Taxes: purchaseOrder.taxes,
                ProjectNo: purchaseOrder.projectNo,
                Delivery: purchaseOrder.delivery,
                Transport: purchaseOrder.transport,
                Validity: purchaseOrder.validity,
                specialInstruction: purchaseOrder.specialInstruction,
                Insurance: purchaseOrder.insurance,
                PackingStandard: purchaseOrder.packingStandard,
                Quality: purchaseOrder.quality,
                Freight: purchaseOrder.freight,
                FreightAmount: purchaseOrder.freightAmount,
                PackingForwarding: purchaseOrder.packingForwarding,
                projectBoMId: purchaseOrder.projectBoMId,
                projectName: purchaseOrder.projectName || '',
                quoteRefNo: purchaseOrder.quoteRefNo,
                // quoteDate: purchaseOrder.quoteDate,   
                FinalTaxableAmt: purchaseOrder.finalTaxableAmt,
                GSTRateOnPNF: purchaseOrder.gstRateOnPNF,
                DiscountAmount: purchaseOrder.discountAmount,
                GSTRateOnFreight: purchaseOrder.gstRateOnFreight,
                GSTOnPNFAmount: purchaseOrder.gstOnPNFAmount,
              };

              const disableStatuses = [
                'Rejected by POAdmin',
                'Rejected',
                'Approved',
                'Process',
                'Close'
              ];

              if (disableStatuses.includes(purchaseOrder.purchaseOrder_Status)) {
                Object.keys(this.purchaseOrderForm.controls).forEach(key => {
                  if (key !== 'amendmentNo' && key !== 'amendmentDate') {
                    this.isFormLocked = false;
                  } else {
                    this.isFormLocked = true;
                  }
                });
              } else {
                this.purchaseOrderForm.enable();
              }

              if (purchaseOrder.projectBoMCode) {
                this.inventoryService.getProjectBomCode(purchaseOrder.projectBoMCode).subscribe(
                  (projectDetails: any) => {
                    formPatch.projectBOMCode = projectDetails?.projectBoMName || 'Unknown Project';
                    this.purchaseOrderForm.patchValue(formPatch);
                  },
                  (error: any) => {
                    console.log('Error fetching project details:', error);
                    formPatch.projectBOMCode = 'N/A';
                    this.purchaseOrderForm.patchValue(formPatch);
                  }
                );
              } else {
                formPatch.projectBOMCode = '';
                this.purchaseOrderForm.patchValue(formPatch);
              }

              if (purchaseOrder.purchaseOrder_Status == 'Pending Approval') {
                this.getSystemConfigData();
              }



              this.warehouseState = purchaseOrder.warehouse?.address?.state || '';
              this.vendorState = purchaseOrder.vendor?.address?.state || '';
              this.orderTotal = purchaseOrder.poTotal;
              this.weightTotal = purchaseOrder.totalWeight;
              this.TaxTotal = purchaseOrder.taxTotal;
              this.CGSTtotal = purchaseOrder.cgstTotal;
              this.SGSTtotal = purchaseOrder.sgstTotal;
              this.IGSTtotal = purchaseOrder.igstTotal;
              this.vendorEmail = purchaseOrder.vendor.email;
              this.vendorName = purchaseOrder.vendor.vendorName;
              this.isIGST = purchaseOrder.igstTotal !== 0;

              // if (purchaseOrder.vendorId) {
              //   this.loadVendorOutstandingPayables(purchaseOrder.vendorId);
              // }

              this.status = purchaseOrder.purchaseOrder_Status;
              if (typeof this.status === 'string' && ['Process', 'Rejected PO', 'Close'].includes(this.status)) {
                this.purchaseOrderForm.get('termsCode')?.disable();
                this.purchaseOrderForm.get('projectName')?.disable();
              }

              if (purchaseOrder.shipToCustomerId) {
                this.getShipto(purchaseOrder.shipToCustomerId);
              }

              const data = purchaseOrder.purchaseOrderNumber;
              this.porderservice.getPurchaseOrderLineitemById(data).subscribe(
                (lineItemsData: any) => {
                  this.products = this.loadProducts(lineItemsData);
                  this.allProductData = this.products;
                  this.calculateOrderTotal();
                },
                (error: any) => {
                  console.log('Error fetching purchase order lineitems:', error);
                }
              );
            } else {
              this.loader = false;
            }
          },
          (error: any) => {
            this.loader = false;
            console.log('Error fetching purchase order:', error);
          }
        );
      }
    });
  }


  async getProjectNameByBoMCode(projectBoMCode: string): Promise<string> {
    try {
      const response = await this.inventoryService.getProjectBomCode(projectBoMCode).toPromise();
      return response?.projectBoMName;
    } catch (error) {
      console.error("Error retrieving project name:", error);
      return 'Unknown Project';
    }
  }
  getShipto(data: number) {
    this.loader = true;
    this.customerService.getCustomerById(data).subscribe({
      next: (data: any) => {
        const ShipTo = data;
        this.purchaseOrderForm.controls.ShipToCustomer.setValue(ShipTo.customerName);
        const address = `${ShipTo.address.city, ShipTo.address.state}, ${ShipTo.address.country}, ${ShipTo.address.zip}`;
        this.purchaseOrderForm.controls.ShipToCustomerAddress.setValue(address);
        this.loader = false;

      },
      error: error => {
        console.log(error);
        this.loader = false;
      }
    })
  }


  loadProducts(data: any): Product[] {
    // return data.map((item: any) => {
    //   return this.loadProduct(item);
    // });
    const products: Product[] = data.map((item: any) => {
      return this.loadProduct(item);
    });

    products.sort((a, b) => {
      return a.LineItemNumber - b.LineItemNumber;
    });

    return products;
  }

  loadProduct(data: any) {
    const qty = Number(data.poQuantity) || 0;
    const cost = Number(data.cost) || 0;
    const discPct = normalizeDiscountPercentOnLoad(
      Number(data.discount ?? data.Discount ?? 0),
      qty,
      cost
    );
    const product: Product = <Product>{
      purchaseOrderLineItemId: data.purchaseOrderLineItemId,
      PurchaseOrderNumber: data.purchaseOrderNumber,
      ProductId: data.productId,
      POQuantity: data.poQuantity,
      ReceivedQuantity: data.receivedQuantity,
      DateRequired: (data.dateRequired) ? new Date(data.dateRequired) : new Date,
      Uom: data.uom,
      projectBoMId: data.projectBoMId,
      projectBoMName: data.projectBOM?.projectBoMName || '',
      LineItemNumber: data.lineItemNumber,
      IsTaxable: data.isTaxable,
      Cost: data.cost,
      Discount: discPct,
      UnitPrice: data.unitPrice,
      ExtendedCost: data.extendedCost,
      GSTRate: data.gstRate,
      Weight: data.weight,
      HSNCode: data.hsnCode,
      CGST: data.cgst,
      SGST: data.sgst,
      IGST: data.igst,
      ProductCode: data.productCode,
      ProductDescription: data.productDescription,
      ProductSpecification: data.productSpecification,
      Comment: data.comment,
      CreatedBy: data.createdBy,
      IsActive: true,
    }
    return product;
  }

  checkPurchaseNumber() {
    if (!this.purchaseOrderForm.controls.purchaseOrderNumber.value) {
      return;
    }
    if (this.products.length > 0) {
      return;
    }
    if (!this.isEditMode) {
      this.porderservice.checkPurchaseOrderNumber(this.purchaseOrderForm.controls.purchaseOrderNumber.value).subscribe(
        (data: any) => {
          if (data.success == true) {
            // console.log(data);
          } else {
            this.purchaseOrderForm.controls.purchaseOrderNumber.setValue('');
            this.messageService.add({ severity: 'error', summary: 'Failed', detail: data.message });
            this.purchaseOrderForm.controls.manualEntry.setValue(true);
          }
        },
        (error: any) => {
          console.log(error);
        }
      );
    }
  }



  focusNextInput(event: Event): void {
    const keyboardEvent = event as KeyboardEvent;
    keyboardEvent.preventDefault();

    const target = keyboardEvent.target as HTMLElement;
    const formElements = Array.from((target.closest('form') as HTMLFormElement).elements) as HTMLElement[];
    const index = formElements.indexOf(target);

    if (index > -1 && index < formElements.length - 1) {
      const nextElement = formElements[index + 1];
      nextElement.focus();
    }
  }

  viewProduct(data?: any) {
    const productData = data || this.selectedProduct[0];
    const normalizedData = this.normalizeProductIdInPlace(productData);
    const productDataJson = JSON.stringify(normalizedData);
    this.productId = normalizedData.productId;

    const ref = this.dialogService.open(viewproductLookupComponent, {
      header: 'Product Details',
      width: '70%',
      data: {
        productData: productDataJson,
        productId: this.productId
      }
    });

    let messageShown = false;

    ref.onClose.subscribe(updatedProduct => {
      if (updatedProduct && !messageShown) {
        this.updateProductInGrid(productData, updatedProduct);

        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: `Product updated successfully.`
        });
        messageShown = true;
      }
    });
  }

  updateProductInGrid(originalProduct: any, updatedProduct: any) {
    originalProduct.ProductCode = updatedProduct.ProductCode;
    originalProduct.ProductDescription = updatedProduct.ProductName;
    originalProduct.Uom = updatedProduct.unitsofMeasure || updatedProduct.UnitsOfMeasure;
    originalProduct.HSNCode = updatedProduct.HSNCode;
    originalProduct.projectBoMId = updatedProduct.projectBoMId;
    originalProduct.GSTRate = updatedProduct.gstRate;
    originalProduct.Cost = updatedProduct.StandardCost;
    originalProduct.ProductSpecification = updatedProduct.ProductSpecification;
    void this.calculateOrderTotal();
  }



  private normalizeProductIdInPlace(product: any): any {
    if (product && product.ProductId) {
      product.productId = product.ProductId;
      delete product.ProductId;
    }

    return product;
  }

  getUserList(): void {
    if (this.isEditMode) {
      return;
    }
    this.loader = true;
    this.warehouseService.getAllUser().subscribe({
      next: (data: any) => {
        this.userList = data;
        this.setRoles();
        this.setRolesNew();
        this.loader = false;
      },
      error: error => {
        console.error('Error fetching user info:', error);
        this.loader = false;
      }
    });
  }

  setRolesNew() {
    const authData = JSON.parse(localStorage.getItem('auth') || '{}');
    const userId = authData?.user?.id;

    if (!userId || !Array.isArray(this.userList)) {
      console.warn('Invalid userId or userList not available');
      return;
    }

    const matchedUser = this.userList.find((user: any) =>
      Number(user.userId) === Number(userId)
    );

    if (matchedUser && matchedUser.userRoles?.length > 0) {

      this.userRoles = matchedUser.userRoles.map((ur: any) =>
        ur.role?.roleName
      );

      this.isAdmin = this.userRoles.includes('Admin');
      this.isPOAdmin = this.userRoles.includes('PoAdmin');

      this.isUser = !this.isAdmin && !this.isPOAdmin;

    } else {
      this.isUser = true;
    }
  }

  setRoles() {
    const authData = JSON.parse(localStorage.getItem('auth') || '{}');
    const userId = authData?.user?.id;

    if (!userId || !Array.isArray(this.userList)) {
      console.warn('Invalid userId or userList not available');
      return;
    }

    const matchedUser = this.userList.find((user: any) => Number(user.userId) === Number(userId));

    if (matchedUser && matchedUser.userRoles?.length > 0) {
      this.adminUser = matchedUser.userRoles[0]?.role?.roleName || 'Unknown';
      console.log("ADMIN ", this.adminUser);

    } else {
      this.adminUser = 'Unknown';
    }
  }

  setWarehouseFromSession(): void {
    const authData = JSON.parse(localStorage.getItem('auth') || '{}');
    const userId = authData.user?.id;

    const user = this.userList.find((u: { userId: number; warehouseId?: number }) => u.userId === userId);
    if (user) {
      const warehouseId = user.warehouseId;
      if (warehouseId) {
        this.purchaseOrderForm.controls.warehouseId.setValue(warehouseId);

        this.setWarehouseName(warehouseId);

        this.setPurchaseOrderNumber(warehouseId);
      } else {
        console.warn(`No warehouse ID found for user ID: ${userId}`);
      }
    } else {
      console.warn(`User not found with user ID: ${userId}`);
    }
  }

  setPurchaseOrderNumber(warehouseId: number): void {
    const selectedWarehouse = this.warehouseDropdown.find(
      (warehouse: { warehouseId: number }) => warehouse.warehouseId === warehouseId
    );

    if (selectedWarehouse) {
      const unitSerial = selectedWarehouse.unitSerial;
      this.purchaseOrderForm.controls['unitSerial'].setValue(unitSerial);

      this.getManualEntry();
    } else {
      console.warn(`Warehouse not found for warehouse ID: ${warehouseId}`);
    }
  }


  setWarehouseName(warehouseId: number): void {
    const warehouse = this.warehouseDropdown.find(w => w.warehouseId === warehouseId);
    if (warehouse) {
      this.purchaseOrderForm.controls.warehouseName.setValue(warehouse.warehouseName);
      const address = `${warehouse.address.addressLine1}, ${warehouse.address.city} , ${warehouse.address.state} , ${warehouse.address.country} , ${warehouse.address.zip}`;
      this.purchaseOrderForm.controls.warehouseAddress.setValue(address);
      this.warehouseState = warehouse.address.state;
    }
  }

  async toggleEdit(product: Product, field: 'Weight' | 'Quantity') {
    try {
      const productData = await this.getProductById(product.ProductId);
      const costCalculationType = productData.costCalculation || 'Qty';
      this.isEditingQuantity = false;
      this.isEditingWeight = false;
      if (costCalculationType === 'Qty' && field === 'Quantity') {
        this.isEditingQuantity = true;
      } else if (costCalculationType === 'Wgt' && field === 'Weight') {
        this.isEditingWeight = true;
      }
      // else if (costCalculationType === 'Wgt' && field === 'Quantity') {
      //   this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'Cannot edit Quantity because the product type is Weight (Wgt).' });
      //   return;
      // } else if (costCalculationType === 'Qty' && field === 'Weight') {
      //   this.messageService.add({ severity: 'error', summary: 'Invalid Value', detail: 'Cannot edit Weight because the product type is Quantity (Qty).' });
      //   return;
      // }
    } catch (error) {
      console.error('Error fetching product data:', error);
    }
  }

  getFormControlName(): string {
    return this.productCostCalculationType === 'Qty' ? 'productQty' : 'productWgt';
  }

  getPlaceholder(): string {
    return this.productCostCalculationType === 'Qty' ? 'Qty' : 'Wgt';

  }

  onKeydown(event: KeyboardEvent, product: any) {
    if (event.key === 'Enter' || event.key === 'Tab') {
      event.preventDefault();
      this.onProductEdit(product);
      if (event.key === 'Tab') {
        this.moveFocusToNextField(event, product);
      }
    }
  }

  moveFocusToNextField(event: KeyboardEvent, product: any) {
    const inputs = document.querySelectorAll('input');
    const currentIndex = Array.from(inputs).indexOf(event.target as HTMLInputElement);
    const nextInput = inputs[currentIndex + 1] as HTMLInputElement;

    if (nextInput) {
      nextInput.focus();
    }
  }

  createQuickProduct() {
    this.submitted = true;

    const isValid = this.validateCustomer();
    if (!isValid) {
      window.scroll(0, 0);
      return;
    }

    this.ref = this.dialogService.open(CloseQuickProductLookupComponent, {
      header: 'Create Quick Product',
      width: '70%',

    });
    this.ref.onClose.subscribe((data: Product) => {
      if (data) {
        const product = { value: data };
        this.setProduct(product);
      }
    });
  }


  createQuickProject() {
    this.ref = this.dialogService.open(CreateQuickProjectComponent, {
      header: 'Create Quick Project',
      width: '50%',
      height: '48%'
    });

    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.purchaseOrderForm.patchValue({
          projectName: data.projectBoMName,
          ProjectNo: data.projectBoMCode
        });
      }
    });
  }

  getProjectLookup(productItem: projects) {
    this.ref = this.dialogService.open(ProjectBomLookupComponent, {
      header: 'Project List',
      width: '70%',
    });
    this.ref.onClose.subscribe((selected: projects) => {
      if (selected) {
        productItem.projectBoMName = selected.projectBoMName;
        productItem.projectBoMId = selected.projectBoMId;
      }
    });
  }

  showComment(productItem: Product) {
    this.ref = this.dialogService.open(POCommentsLookupComponent, {
      header: 'Purchase Order Line Remark',
      width: '50%',
      data: productItem
    });
    this.ref.onClose.subscribe((data: string) => {
      if (data) {
        productItem.Comment = data;
        this.onProductEdit(productItem);
      }
    });
  }

  openLinkedFiles() {
    if (this.ref) {
      this.ref.close();
    }
    const orderNo = this.purchaseOrderForm.controls.purchaseOrderNumber.value;
    this.ref = this.dialogService.open(ListLinkedFilesLookupComponent, {
      header: `Linked File For Order ${orderNo}`,
      width: '60%',
      data: { orderNo: orderNo }
    });
  }

  createQuickVendor() {
    this.ref = this.dialogService.open(CloseQuickVendorLookupComponent, {
      header: 'Create Quick Vendor',
      width: '70%',

    });
    this.ref.onClose.subscribe((vendorId: number) => {
      if (vendorId) {
        this.getVendorData(vendorId);
      }
    });
  }

  getVendorData(id: number) {
    this.vendorService.getVendorById(id).subscribe(
      (data: any) => {
        const VendorData = {
          value: data
        }
        this.setVendor(VendorData)
      },
      (error: any) => {
        console.log(error);
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error occurred while fetching vendor data.' });
      }
    );
  }

  showProductUom(productItem: Product) {
    this.ref = this.dialogService.open(UOMLookupComponent, {
      header: 'Unit of Measure',
      width: '60%',

    });
    this.ref.onClose.subscribe((selectedUOM: UnitsOfMeasure) => {
      if (selectedUOM) {
        productItem.Uom = selectedUOM.unitsofMeasure;
        this.onProductEdit(productItem);
      }
    });
  }

  showSpecification(productItem: any) {
    this.ref = this.dialogService.open(SpecificationLookupComponent, {
      header: 'Order Line Specification',
      width: '50%',
      data: productItem
    });
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        productItem.ProductSpecification = data.ProductSpecification;
        this.onProductEdit(productItem);
      }
    });
  }

  getInventoryStatus(productCode: string) {
    const warehouseId = this.purchaseOrderForm.value.warehouseId;
    if (!warehouseId) {
      return;
    }
    this.inventoryService.getInventoryStatus(productCode).subscribe({
      next: (data: any) => {
        if (data.success === false) {
        } else {
          const inventoryItem = data.find((item: { warehouseId: any; }) => item.warehouseId === warehouseId);
          if (inventoryItem) {
            this.QAvail = inventoryItem.quantityAvailable;
          } else {
            console.log(`No inventory item found for warehouse ID: ${warehouseId}`);
          }
        }
      },
      error: error => {
        console.log(error);
      }
    });
  }

  getProduct() {
    this.ref = this.dialogService.open(ProjectBomLookupComponent, {
      header: 'Project List',
      width: '80%',
    })
    this.ref.onClose.subscribe((data: any) => {
      if (data) {
        this.purchaseOrderForm.patchValue({
          projectName: data.projectBoMName,
          ProjectNo: data.projectBoMCode,
          projectBoMId: data.projectBoMId

        })
      }
    })
  }

  clearProject() {
    this.purchaseOrderForm.patchValue({
      projectBoMId: null,
      projectName: '',
      ProjectNo: ''
    });
  }

  showPORejectDialog() {
    if (this.adminUser !== 'Admin') {
      this.messageService.add({
        severity: 'error',
        summary: 'Unauthorized',
        detail: 'You are not authorized to reject the PO. Contact your administrator to proceed.'
      });
      return;
    }
    this.visible = !this.visible;
  }

  reject() {
    if (!this.comment) {
      this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Please enter comment.' });
      return;
    }
    //const status: string = (this.purchaseOrderForm.controls.PurchaseOrder_Status.value == 'Pending Approval') ? 'Rejected PR' : 'Rejected PO';
    const status: string = (this.purchaseOrderForm.controls.PurchaseOrder_Status.value == 'Pending Approval') ? 'Rejected' : 'Rejected';
    this.loader = true
    this.porderservice.updatePOStatus(this.purchaseOrderId, status, this.comment).subscribe({
      next: (data: any) => {
        this.loader = false
        let msg: any = (status == 'Rejected') ? 'PO rejected successfully.' : 'PO rejected successfully.';
        this.messageService.add({ severity: 'success', summary: 'Success', detail: msg });
        setTimeout(() => {
          this.router.navigate(['/home/listPurchaseOrders']);
        }, 800);
      },
      error: error => {
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error occurred while reject.' });
        this.loader = false;
      }
    });
  }

  getGroupIdFromQuery() {
    this.routers.queryParams.subscribe(params => {
      const purchaseOrderId = Number(params['orderId']);
      if (!purchaseOrderId) return;

      this.porderservice.getProductRequisitionById(purchaseOrderId).subscribe({
        next: (data: any) => {

          const selectedDept = this.filterDepartments.find(
            d => d.DepartmentId === data.department?.departmentId
          );

          this.purchaseOrderForm.patchValue({
            ...data,
            requestedDate: data.requestedDate ? new Date(data.requestedDate) : null,

            //departmentName: selectedDept || null,
            //departmentName: data.department || null,
            departments: data.department?.departmentCode,
            departmentName: data.department?.departmentName,

            // From warehouse object
            warehouseId: data.warehouse?.warehouseId || '',
            warehouseCode: data.warehouse?.warehouseCode || '',
            warehouseName: data.warehouse?.warehouseName || '',
            warehouseAddress: data.warehouse?.address
              ? `${data.warehouse.address.addressLine1}, ${data.warehouse.address.addressLine2}, ${data.warehouse.address.city}, ${data.warehouse.address.state}, ${data.warehouse.address.zip}, ${data.warehouse.address.country}`
              : '',
            unitSerial: data.warehouse?.unitSerial || '',

            // // Vendor info (assuming 'add' = vendor address)
            vendorName: data.vendorName || '',
            add: data.add || '',
            createdDate: data.createdDate ? new Date(data.createdDate) : null,
          });

          this.warehouseState = data.warehouse?.address?.state || '';

          if (data.warehouse?.unitSerial) {
            this.getManualEntry();
          }

          this.PRStatus = data.status;

          const requisitionNumber = data.productRequisitionNumber;
          if (requisitionNumber) {
            this.porderservice.getProductRequisitionLineitemById(requisitionNumber).subscribe(
              async (lineItemsData: any[]) => {
                //console.log('lineItems:', lineItemsData);

                // Step 1: Load products
                this.products = this.loadProducts(lineItemsData);
                this.allProductData = this.products;

                await Promise.all(
                  this.products.map(async (product) => {
                    try {
                      const productData = await this.getProductById(product.ProductId);
                      product.CostCalculation = productData.costCalculation || 'Qty';
                    } catch (error) {
                      product.CostCalculation = 'Qty';
                    }
                  })
                );

                if (this.PRStatus === 'Approved') {
                  setTimeout(() => {
                    const btn1 = document.getElementById('shipTocustomer') as HTMLButtonElement;
                    if (btn1) {
                      btn1.removeAttribute('disabled');
                      btn1.disabled = false;
                    }

                    const btn2 = document.getElementById('vendorButton') as HTMLButtonElement;
                    if (btn2) {
                      btn2.removeAttribute('disabled');
                      btn2.disabled = false;
                    }
                    const btn3 = document.getElementById('quickVendor') as HTMLButtonElement;
                    if (btn3) {
                      btn3.removeAttribute('disabled');
                      btn3.disabled = false;
                      this.cdr.detectChanges();
                    }
                  }, 0);
                }

              },
              (error: any) => {
                console.error('Error fetching Product Requisition line items:', error);
              }
            );
          }
        },
        error: error => console.error(error),
      });
    });
  }

  getUnitLabel(): void {
    this.loader = true;
    const appKey = 'unitNameLabel';

    this.inventoryService.getUnitByAppKey(appKey).subscribe({
      next: (response: any) => {
        this.loader = false;
        if (response?.appKeycode === appKey) {
          this.unitLabel = response?.data;
        } else {
          this.unitLabel = 'Unit';
        }
      },
      error: error => {
        console.error('Error fetching Unit Label:', error);
        this.unitLabel = 'Unit';
        this.loader = false;
      }
    });
  }


  getDeptLabel(): void {
    this.loader = true;
    const appKey = 'DeptLabel';

    this.inventoryService.getDeptByAppKey(appKey).subscribe({
      next: (response: any) => {
        this.loader = false;
        if (response?.appKeycode === appKey) {
          this.DeptLabel = response?.data;
        } else {
          this.DeptLabel = 'Department';
        }
      },
      error: error => {
        console.error('Error fetching Department Label:', error);
        this.DeptLabel = 'Department';
        this.loader = false;
      }
    });
  }


  async updateFreightAndPF() {
    await this.calculateOrderTotal();
    this.cdr.detectChanges();
  }


  onSavePopupHide() {
    this.savePopupVisible = false;
  }

  showSaveOptionsPopup() {
    if (this.autoSendEmail) {
      this.savePopupVisible = true;
    } else {
      this.performAction('Submit', false);
    }
  }

  saveOnly() {
    this.savePopupVisible = false;
    this.performAction('Submit', false);
  }

  saveAndSend() {
    this.savePopupVisible = false;
    this.performAction('Submit', true);
  }


  sendOrderEmail(order: any, onComplete?: () => void) {
    const authString = localStorage.getItem('auth');
    if (!authString) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Auth information is missing' });
      onComplete?.();
      return;
    }

    const auth = JSON.parse(authString);
    if (!auth.tenant?.tenantCode) {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Tenant Code is missing' });
      onComplete?.();
      return;
    }

    const tenant = auth.tenant.tenantCode;
    const formCode = 'PurchaseOrder';

    this.loader = true;

    this.getUserDepartmentName().subscribe(departmentName => {

      this.reportService.getReportName(formCode).pipe(
        switchMap((report: any) => {
          if (!report?.path) {
            throw new Error('REPORT_MISSING');
          }
          this.ReportPath = report.path;

          return this.salesService.getEmailTemplate(tenant, 'purchase-order-submit-template');
        }),
        switchMap((templateResponse: any) => {
          const template = templateResponse?.body ??
            templateResponse?.Body ??
            templateResponse?.templateBody ??
            templateResponse?.TemplateBody ??
            templateResponse?.emailBody ??
            templateResponse?.EmailBody;

          if (!template) {
            throw new Error('TEMPLATE_MISSING');
          }

          const templateData = {
            vendorName: this.purchaseOrderForm.controls.vendorName.value || order?.vendorName || '',
            orderNumber: this.purchaseOrderForm.controls.purchaseOrderNumber.value || order?.purchaseOrderNumber || '',
            PONumber: this.purchaseOrderForm.controls.purchaseOrderNumber.value || order?.purchaseOrderNumber || '',
            CustomerPONumber: this.purchaseOrderForm.controls.purchaseOrderNumber.value || order?.purchaseOrderNumber || '',
            PODate: formatDateDDMMYY(this.purchaseOrderForm.controls.createdDate.value),
            currentYear: new Date().getFullYear(),
            companyName: this.companyInfo?.companyName || '',
            companyEmail: this.companyInfo?.companyEmail || '',
            companyPhone: this.companyInfo?.companyPhone || '',
            companyWebsite: this.companyInfo?.companyWebsite || '',
          };

          return of(this.emailTemplateService.replacePlaceholders(template, templateData));
        }),
        switchMap((emailBody: string) => {
          const emailToId = this.vendorEmail;

          if (!emailToId) {
            throw new Error('EMAIL_MISSING');
          }

          const purchaseOrderNumber = this.purchaseOrderForm.controls.purchaseOrderNumber.value || order?.purchaseOrderNumber || 'N/A';

          const emailData = {
            EmailToId: emailToId,
            EmailToName: this.vendorName,
            EmailSubject: `Purchase Order ${purchaseOrderNumber} from ${this.companyInfo?.companyName || 'our company'}`,
            EmailBody: emailBody,
            OrderNumber: purchaseOrderNumber,
            OrderType: 'PurchaseOrder',
            TenantId: tenant,
            ReportPath: this.ReportPath,
            DepartmentName: departmentName
          };

          return this.salesService.SendMail(emailData).pipe(
            map(() => order)
          );
        }),
        catchError(err => {
          console.warn('Purchase Order email skipped:', err.message);
          this.loader = false;
          this.messageService.add({
            severity: 'warn',
            summary: 'Warning',
            detail: 'Emails were not sent because required data (report / email / template) was missing.'
          });
          onComplete?.();
          return EMPTY;
        })
      ).subscribe({
        next: () => {
          this.loader = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: 'Purchase Order email sent successfully with report attachment.'
          });
          this.createRecentInteractions(onComplete, departmentName);
        },
        error: (err: any) => {
          this.loader = false;
          console.error('Unexpected error:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Report not found. Email cannot be sent without report.'
          });
          onComplete?.();
        }
      });
    });
  }

  getCompanyDetails() {
    this.warehouseService.getCompanyDetails().subscribe(
      (data: any) => {
        if (data && data.length > 0) {
          const company = data[0];
          this.companyInfo = {
            companyName: company.companyName,
            companyEmail: company.emailID1,
            companyPhone: company.mobile,
            companyWebsite: `https://${company.website?.replace(/^https?:\/\//, '')}`,
          };
        }
      },
      (error: any) => {
        console.log(error);
      }
    );
  }

  createRecentInteractions(onComplete?: () => void, departmentName: string = '') {
    const formData = this.purchaseOrderForm.value;
    const nowUTC = new Date();
    const istOffset = 5.5 * 60 * 60 * 1000;
    const istDate = new Date(nowUTC.getTime() + istOffset);

    const appKey = departmentName ? `dept.email.${departmentName}` : 'emailid';

    this.inventoryService.getSystemConfigByAppKey(appKey).subscribe({
      next: (config: any) => {
        const fromEmail = config?.data || 'default@example.com';

        const recentInteraction: RecentInteractions = {
          sendDate: istDate,
          type: "Send Mail",
          from: fromEmail,
          to: this.vendorEmail || 'default@example.com',
          subject: `Purchase Order ${this.purchaseOrderForm.controls.purchaseOrderNumber.value || ''}`,
          vendorNumber: formData.vendorCode ?? '',
          refId: this.purchaseOrderId || 0,
          description: "Purchase Order successfully placed",
          createdBy: localStorage.getItem('username') || '',
          isActive: true
        };

        this.salesService.createRecentInteractions(recentInteraction).subscribe({
          next: (response) => {
            console.log('Recent interaction created successfully:', response);
            onComplete?.();
          },
          error: (err) => {
            console.error('Error creating recent interaction:', err);
            onComplete?.();
          }
        });
      },
      error: err => console.error('Recent interaction error:', err)
    });
  }

  getUserDepartmentName(): Observable<string> {
    const authString = localStorage.getItem('auth');
    if (!authString) return of('');

    const auth = JSON.parse(authString);
    const user = auth?.user;

    if (!user?.id) return of('');

    return this.warehouseService.getUserById(user.id).pipe(
      switchMap((userData: any) => {
        const departmentId =
          userData?.departmentId;

        if (!departmentId) return of('');

        return this.porderservice.getDepartmentById(departmentId);
      }),
      map((departmentData: any) => {
        return departmentData?.departmentName;
      }),
      catchError(err => {
        console.error('Error fetching department name:', err);
        return of('');
      })
    );
  }

  createQuickPaymentTerms() {
    this.ref = this.dialogService.open(CloseQuickPaymentTermsLookupComponent, {
      header: 'Create Quick Payment Terms',
      width: '70%',
    });
    this.ref.onClose.subscribe((paymentTermsData: any) => {
      if (paymentTermsData) {
        this.purchaseOrderForm.patchValue({
          termsCode: paymentTermsData.paymentTermsDescription
        });
      }
    });
  }

  createQuickCustomer() {
    this.ref = this.dialogService.open(CloseQuickCustomerLookupComponent, {
      header: 'Create Quick Customer',
      width: '70%',
    });
    this.ref.onClose.subscribe((customerId: number) => {
      if (customerId) {
        this.getCustomerData(customerId);
      }
    });
  }

  getCustomerData(id: number) {
    this.customerService.getCustomerById(id).subscribe(
      (data: any) => {
        const customerData = {
          value: data
        };
        if (data.isShipToCustomer === true) {
          this.setShipTo(customerData);
        } else {
          this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'It cannot be shipped to the customer.' });
        }
      },
      (error: any) => {
        console.log(error);
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error occurred while fetching customer data.' });
      }
    );
  }

  // get showPOLineItemSection(): boolean {
  //   const status = this.purchaseOrderForm.get('PurchaseOrder_Status')?.value;
  //   return status !== 'Process' && status !== 'Rejected PO' && status !== 'Close' && status !== 'Rejected PR';
  // }

  get showPOLineItemSection(): boolean {
    const status = this.purchaseOrderForm.get('PurchaseOrder_Status')?.value;

    return status !== this.POStatus.Rejected &&
      status !== this.POStatus.RejectedByPOAdmin &&
      // status !== this.POStatus.Approved &&
      status !== "Close" && status !== "Process";
  }


  getSystemConfigData(): void {
    this.loader = true;
    const configs = ['PO_LIMIT', 'emailid', 'auto_purchase_order_email'];
    const requests = configs.map(key =>
      this.inventoryService.getSystemConfigByAppKey(key)
    );

    forkJoin(requests).subscribe({
      next: (responses: any[]) => {
        responses.forEach(response => {
          switch (response?.appKeycode) {

            case 'PO_LIMIT':
              if (response?.data > 0) {
                this.isPOLimitWarning = true;
                this.POLimit = _.toNumber(response.data);
              }
              break;

            case 'auto_purchase_order_email':
              this.canSendEmail = true;
              this.autoSendEmail = response?.data === 'Y';
              break;

          }
        });

        this.loader = false;
      },
      error: error => {
        console.error('Error fetching System Config Data:', error);
        this.loader = false;
      }
    });
  }

  POStatus = {
    PendingLevel1Approval: 'Pending Level 1 Approval',
    PendingAdminApproval: 'Pending Admin Approval',
    RejectedByPOAdmin: 'Rejected by POAdmin',
    Ready: 'Ready',
    Approved: 'Approved',
    Rejected: 'Rejected'
  };

  rejectPoAdmin() {
    if (!this.comment) {
      this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Please enter comment.' });
      return;
    }
    const status: string = (this.purchaseOrderForm.controls.PurchaseOrder_Status.value == 'Pending Level 1 Approval') ? 'Rejected by POAdmin' : 'Rejected by POAdmin';
    //const status: string = (this.purchaseOrderForm.controls.PurchaseOrder_Status.value == 'Pending Level 1 Approval') ? 'Rejected by POAdmin' : 'Rejected PO';
    this.loader = true
    this.porderservice.updatePOStatusForPoAdmin(this.purchaseOrderId, status, this.comment).subscribe({
      next: (data: any) => {
        this.loader = false
        let msg: any = (status == 'Rejected by POAdmin') ? 'PR rejected successfully.' : 'PO rejected successfully.';
        this.messageService.add({ severity: 'success', summary: 'Success', detail: msg });
        setTimeout(() => {
          this.router.navigate(['/home/listPurchaseOrders']);
        }, 800);
      },
      error: error => {
        this.messageService.add({ severity: 'error', summary: 'Failed', detail: 'Error occurred while reject.' });
        this.loader = false;
      }
    });
  }

  performApproval(action: string, sendEmail: boolean = false) {

    if (!this.isPOAdmin) {
      this.messageService.add({
        severity: 'error',
        summary: 'Unauthorized',
        detail: 'You are not authorized to perform this action.'
      });
      return;
    }

    const data = { ...this.purchaseOrderForm.value };

    if (action === 'Approve') {

      if (this.orderTotal > this.POLimit) {

        data.PurchaseOrder_Status = this.POStatus.PendingAdminApproval;

        this.messageService.add({
          severity: 'warn',
          summary: 'Limit Exceeded',
          detail: 'PO amount exceeds the approval limit. Contact your administrator to proceed.',
          life: 1000
        });

      } else {

        data.PurchaseOrder_Status = this.POStatus.Approved;

        // this.messageService.add({
        //   severity: 'success',
        //   summary: 'Approved',
        //   detail: 'PO approved successfully.'
        // });
      }

      this.updatePO(data, sendEmail);
    }

    if (action === 'Reject') {
      this.visiblePoAdmin = true;
    }
  }

  getPoAdminSetting(): void {
    this.inventoryService
      .getUnitByAppKey('enable.po.level1.approval')
      .subscribe({
        next: (res: any) => {
          this.isPoAdminEnabled = res?.data?.toString().toUpperCase() === 'Y';
        },
        error: (err) => {
          console.error('PO Admin setting fetch failed', err);
          this.isPoAdminEnabled = false;
        }
      });
  }

  canAdminApprove(): boolean {
    const status = this.purchaseOrderForm.controls.PurchaseOrder_Status.value;

    return (
      this.isEditMode &&
      this.adminUser === 'Admin' &&
      status !== 'Approved' &&
      status !== 'Rejected by POAdmin' &&
      status !== 'Rejected' &&
      status !== 'Process' &&
      status !== 'Close' &&
      status !== 'Amended'
    );
  }

  gstOptions = [
    { label: 'GST0 - (0%)', value: 0 },
    { label: 'GST5 - (5%)', value: 5 },
    { label: 'GST12 - (12%)', value: 12 },
    { label: 'GST18 - (18%)', value: 18 },
    { label: 'GST28 - (28%)', value: 28 }
  ];

  calculateFreightGST() {
    const freight = Number(this.purchaseOrderForm.get('FreightAmount')?.value) || 0;
    const rate = Number(this.purchaseOrderForm.get('GSTRateOnFreight')?.value) || 0;
    const gstAmount = (freight * rate) / 100;
    this.purchaseOrderForm.patchValue({
      GSTOnFreight: Number(gstAmount.toFixed(2))
    }, { emitEvent: false });
  }

  calculatePFGST() {
    const pfCharges = Number(this.purchaseOrderForm.get('PackingForwarding')?.value) || 0;
    const gstRate = Number(this.purchaseOrderForm.get('GSTRateOnPNF')?.value) || 0;
    const gstAmount = (pfCharges * gstRate) / 100;
    this.purchaseOrderForm.patchValue({
      GSTOnPNFAmount: Number(gstAmount.toFixed(2))
    }, { emitEvent: false });
  }

  checkLineItemDiscounts() {
    void this.calculateOrderTotal();
  }

  isLineDiscountDisabled(): boolean {
    return false;
  }

  showSaveOptions() {

    if (!this.purchaseOrderForm.valid) {
      this.messageService.add({
        severity: 'warn',
        summary: 'Validation',
        detail: 'Please fill all required fields before saving.'
      });
      return;
    }

    this.saveConfirmVisible = true;
  }

  confirmSave() {
    this.saveConfirmVisible = false;
    this.performAction('Save', false);
  }

  onUpdateClick() {
    //const status = this.purchaseOrderForm.controls.PurchaseOrder_Status.value;

    // if (status === 'Approved' || status === 'Amended') {
    //   this.showUpdateCommentDialog = true;
    // } else {
    //   this.updatePO(this.purchaseOrderForm.value);
    // }
    //this.updatePO(this.purchaseOrderForm.value);

    const data = { ...this.purchaseOrderForm.value };
    data.PurchaseOrder_Status = 'Amended';
    this.updatePO(data);
  }

  confirmUpdateApprovedPO() {

    if (!this.updateComment || this.updateComment.trim() === '') {
      this.messageService.add({
        severity: 'error',
        summary: 'Comment Required',
        detail: 'Please enter comment before amending PO.'
      });
      return;
    }

    const data = { ...this.purchaseOrderForm.value };
    data.PurchaseOrder_Status = 'Amended';
    data.purchaseOrderComment = this.updateComment;

    this.updateComment = '';
    this.showUpdateCommentDialog = false;

    this.updatePO(data);
  }

  onCancelUpdateComment() {
    this.updateComment = '';
    this.showUpdateCommentDialog = false;
  }

  resetUpdateComment() {
    this.updateComment = '';
  }

  showApproveOptions() {
    if (!this.isPOAdmin) {
      this.messageService.add({
        severity: 'error',
        summary: 'Unauthorized',
        detail: 'You are not authorized to perform this action.'
      });
      return;
    }

    if (this.orderTotal > this.POLimit) {
      this.performApproval('Approve');
      return;
    }

    this.approvePopupVisible = true;
  }

  approveOnly() {
    this.approvePopupVisible = false;
    this.performApproval('Approve', false);
  }

  approveAndSend() {
    this.approvePopupVisible = false;
    this.performApproval('Approve', true);
  }

}


